<agenx-header></agenx-header>
<main class="agenx-dashboard">
  @if (show_totals && micros_values.length > 0) {
    @if (no_internet) {
      <agenx-card title="" [line]="false">
        <div style="margin-bottom: 0.4rem;">
          <agenx-alert
            [alertText]="'Actualmente no cuenta con una conexión estable a internet, ' +
            'por lo que algunas funciones estan limitadas.'"
            alertType="warning" [loading]="false"></agenx-alert>
        </div>
      </agenx-card>
    }
    @if (gauging_pends.length > 0 || created_pends) {
      <agenx-card title="" [line]="false">
        <div style="margin-bottom: 0.4rem;">
          @if (!created_pends) {
            <agenx-alert
              [alertText]="'Actualmente ' + message_pend +
              ' sin crear, esperando conexión para crear automáticamente.'"
              alertType="info" [loading]="true"></agenx-alert>
          } @else {
            <agenx-alert
              [alertText]="message_pend2"
              alertType="info" [loading]="false"></agenx-alert>
          }
        </div>
      </agenx-card>
    }
    @if (special_pends.length > 0 || created_pends_specials) {
      <agenx-card title="" [line]="false">
        <div style="margin-bottom: 0.4rem;">
          @if (!created_pends_specials) {
            <agenx-alert
              [alertText]="'Actualmente ' + message_pend_spe +
              ' sin crear, esperando conexión para crear automáticamente.'"
              alertType="info" [loading]="true"></agenx-alert>
          } @else {
            <agenx-alert
              [alertText]="message_pend_spe2"
              alertType="info" [loading]="false"></agenx-alert>
          }
        </div>
      </agenx-card>
    }
    <agenx-card [title]="'INFORMACIÓN GENERAL'">
      <div class="agenx-dashboard__inputs--four">
        <div class="info-style">
          <h5>Nombre:</h5>
          <p>{{ user?.name }}</p>
        </div>
        <div class="info-style">
          <h5>Identificación:</h5>
          <p>{{ user?.identification }}</p>
        </div>
        <div class="info-style">
          <h5>Nombre usuario:</h5>
          <p>{{ user?.username }}</p>
        </div>
        <div class="info-style">
          <h5>Fecha:</h5>
          <p>{{ date_today.toLocaleDateString() }}</p>
        </div>
      </div>
    </agenx-card>

    <agenx-card [title]="'TOTALES'" [show]="false">
      <agenx-totals [totalGaugedSub]="gauged_sub"
        [totalMonthSub]="month_subs"
        [totalDaySub]="today_sub"
        [totalGauged]="totals_gauged"
        [totalMonth]="totals_month"
        [totalDay]="totals_today"
        [ordynary]="totals_ordinary"
        [extraOrdynary]="totals_extra"
        [permanent]="totals_permanent"
        [usable]="totals_usable"
        [unusable]="totals_unusable"
        [organic]="totals_organic"
        [todayDate]="today_sub"></agenx-totals>
    </agenx-card>

    <agenx-tab (selectedTab)="setTabs($event)" [tabsObject]="tabs">
    </agenx-tab>
    @switch (tabSelected) {
      @case (tabs!.notGauging.name) {
        <agenx-card [title]="micro_name" [borderTopLess]="true" (buttonClick)="restartMicroTab()"
            [button]="no_internet ? null : btn_restart">
          @if (tabs!.notGauging.loading) {
            <agenx-alert-radio [alertText]="'Consultando información de suscriptores no aforados.'"
              alertType="info" [loading]="true"></agenx-alert-radio>
          }

          @if (micros_select.value === '---') {
            <agenx-select [idInput]="'micros_select'" [control]="micros_select" [options]="micros_values"
            [label]="'Microrrutas'" (onChange)="setMicroroutes($event)"></agenx-select>
          }
          @else {
            @if (tabs!.notGauging.cards?.length === 0 && !tabs!.notGauging.loading) {
              <agenx-alert class="agenx-mb--3" [alertType]="'error'"
                [alertText]="'No hay suscriptores para aforar.'"></agenx-alert>
            }
            <div class="agenx-dashboard__cards">
              @for (subs_card of tabs!.notGauging.recordsShow; track subs_card.valuesContent) {
                <agenx-card-sub [buttonCardText]="!subs_card.alertInfo ? 'Crear Aforo' : ''"
                  [alertCard]="subs_card.alertInfo" [card_info]="subs_card" (selectedCardSub)="goToCreateEdit($event)">
                </agenx-card-sub>
              }
            </div>
          }
          <div class="agenx-mt--4">
            @if (tabs!.notGauging.pages!.length > 0) {
              <agenx-paginator (returnedPage)="setPaginator($event)" [currentPage]="tabs!.notGauging.pageSelect"
                [pages]="tabs!.notGauging.pages!"></agenx-paginator>
            }
          </div>
        </agenx-card>
      }
      @case (tabs!.searchSubs.name) {
        <agenx-card [title]="tabs!.searchSubs.name" [borderTopLess]="true">
          <div class="agenx-dashboard__search">
            <h3 class="agenx-title">
              {{searchType === 'subscribers' ?
                'Niud, número de contrato, dirección, identicación o nombre' :
                'Identificación, nombre, dirección o código' }}</h3>
            <div class="agenx-dashboard__search--inputs">
              <agenx-input [placeholder]="'Escriba aquí su búsqueda.'" [labelPosition]="'top'" [control]="search_input"
                [label]="''" (onEnterPress)="search()" [extraClasses]="'agenx-m--0'"></agenx-input>
              <agenx-button #buttonTest (click)="search()" [buttonText]="'Buscar'" [sizeButton]="'large'"
                [loadingButton]="loading" [disabled]="no_internet"></agenx-button>
            </div>
            <div class="search-radios">
              <agenx-radio [idInput]="'search-subs'" [value]="'subscribers'" [checked]="true"
                [nameInput]="'search-radios'" [label]="'Suscriptores'" [type]="'info'"
                class="agenx-alert-radio__radio" (valueSend)="onClickSearch($event)"></agenx-radio>
              <agenx-radio [idInput]="'search-cli'" [value]="'clients'" [checked]="false"
                [nameInput]="'search-radios'" [label]="'Clientes'" [type]="'info'"
                class="agenx-alert-radio__radio" (valueSend)="onClickSearch($event)"></agenx-radio>
            </div>
            @if (this.tabs!.searchSubs.records?.length === 0) {
              <agenx-alert [alertType]="'error'"
                [alertText]="searchType === 'subscribers' ?
                  'No se encuentran suscriptores' : 'No se encuentran clientes'"></agenx-alert>
            }
          </div>
          <div class="agenx-dashboard__cards">
            @for (subs_card of tabs!.searchSubs.recordsShow; track subs_card.valuesContent) {
              <agenx-card-gauge (selectedCardSub)="onClickSubCard($event)" [modelCard]="'search'"
                  [buttonCardText]="'Crear Aforo'" [card_info]="subs_card">
                </agenx-card-gauge>
            }
          </div>
          <div class="agenx-mt--4">
            @if (tabs!.searchSubs.pages!.length > 0) {
              <agenx-paginator (returnedPage)="setPaginator($event)" [currentPage]="tabs!.searchSubs.pageSelect"
                [pages]="tabs!.searchSubs.pages!"></agenx-paginator>
            }
          </div>
        </agenx-card>
      }
      @case (tabs!.gauging.name) {
        <agenx-card [title]="tabs!.gauging.name" [borderTopLess]="true">
          @if (tabs!.gauging.loading) {
            <agenx-alert-radio [alertText]="'Consultando subcriptores aforados hoy.'"
              alertType="info" [loading]="true"></agenx-alert-radio>
          }
          <div class="agenx-dashboard__cards">
            @for (subs_card of tabs!.gauging.recordsShow; track subs_card.valuesContent) {
            <agenx-card-sub (selectedCardSub)="onClickSubCard($event)" [cardSubButtonType]="'threeButton'"
              [buttonCardText]="'Crear Aforo'" [alertCard]="subs_card.alertInfo"
              [card_info]="subs_card"></agenx-card-sub>
            }
          </div>
          @if (tabs!.gauging.cards?.length === 0 && !tabs!.gauging.loading) {
            <agenx-alert class="agenx-mb--3" [alertType]="'error'"
              [alertText]="'No hay suscriptores aforados hoy.'"></agenx-alert>
          }
          <div class="agenx-mt--4">
            @if (tabs!.gauging.pages!.length > 0) {
              <agenx-paginator (returnedPage)="setPaginator($event)" [currentPage]="tabs!.gauging.pageSelect"
                [pages]="tabs!.gauging.pages!"></agenx-paginator>
            }
          </div>
        </agenx-card>
      }
      @case (tabs!.specialPend.name) {
        <agenx-card [title]="micro_name_spe" [borderTopLess]="true" (buttonClick)="restartMicroTab()"
            [button]="no_internet ? null : btn_restart_spe">
          @if (tabs!.specialPend.loading) {
            <agenx-alert-radio [alertText]="'Consultando aforos especiales pendientes para hoy.'"
              alertType="info" [loading]="true"></agenx-alert-radio>
          }
          @if (micros_select_spe.value === '---') {
            <agenx-select [idInput]="'micros_select_spe'" [control]="micros_select_spe" [options]="micros_values_spe"
            [label]="'Microrrutas'" (onChange)="setMicroroutesSpecial($event)"></agenx-select>
          }
          @else {
            @if (micro_name_spe === 'PROGRAMADOS') {
              <div class="agenx-mb--5">
                <agenx-select [idInput]="'select_prog_spe'" [control]="select_prog_spe" [options]="select_prog_values"
                [label]="'Fecha de programación'" (onChange)="setProgrammedOpt($event)"></agenx-select>
              </div>
            }
            <div class="agenx-dashboard__cards">
              @for (gauge_card of tabs!.specialPend.recordsShow; track gauge_card.id) {
              <agenx-card-gauge (selectedCardSub)="onClickSubCard($event)" [modelCard]="'pend'"
                [buttonCardText]="'Crear Aforo'" [card_info]="gauge_card"
                [typeCard]="gauge_card.date && gauge_card.date !== date_today.toLocaleDateString() ? 'orange' : 'blue'"></agenx-card-gauge>
              }
            </div>
            @if (tabs!.specialPend.filtered?.length === 0 && !tabs!.specialPend.loading) {
              <agenx-alert class="agenx-mb--3" [alertType]="'error'"
                [alertText]="alertNoSpecials"></agenx-alert>
            }
          }
          <div class="agenx-mt--4">
            @if (tabs!.specialPend.filtered!.length > 0) {
              <agenx-paginator (returnedPage)="setPaginator($event)" [currentPage]="tabs!.specialPend.pageSelect"
                [pages]="tabs!.specialPend.pages!"></agenx-paginator>
            }
          </div>
        </agenx-card>
      }
      @case (tabs!.specialDone.name) {
        <agenx-card [title]="tabs!.specialDone.name" [borderTopLess]="true">
          @if (tabs!.specialDone.loading) {
            <agenx-alert-radio [alertText]="'Consultando aforos especiales realizados para hoy.'"
              alertType="info" [loading]="true"></agenx-alert-radio>
          }
          <div class="agenx-dashboard__cards">
            @for (gauge_card of tabs!.specialDone.recordsShow; track gauge_card.id) {
            <agenx-card-gauge (selectedCardSub)="onClickSubCard($event)" [modelCard]="'done'"
              [buttonCardText]="'Crear Aforo'" [card_info]="gauge_card"></agenx-card-gauge>
            }
          </div>
          @if (tabs!.specialDone.records?.length === 0 && !tabs!.specialDone.loading) {
            <agenx-alert class="agenx-mb--3" [alertType]="'error'"
              [alertText]="'No hay aforos especiales realizados para hoy.'"></agenx-alert>
          }
          <div class="agenx-mt--4">
            @if (tabs!.specialDone.records!.length > 0) {
              <agenx-paginator (returnedPage)="setPaginator($event)" [currentPage]="tabs!.specialDone.pageSelect"
                [pages]="tabs!.specialDone.pages!"></agenx-paginator>
            }
          </div>
        </agenx-card>
      }
      @case (tabs!.newClient.name) {
        <agenx-card [title]="tabs!.newClient.name" [borderTopLess]="true">
          <app-new-client-form></app-new-client-form>
        </agenx-card>
      }
    }
  } @else {
    <agenx-alert-radio [alertText]="'Consultando la información del periodo'" alertType="info" [loading]="true"></agenx-alert-radio>
  }
</main>

